"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createListOfProducts = void 0;
const createListOfProducts = items => {
  if (!items) {
    return [];
  }
  return items.map(product => product.tag_based_key);
};
exports.createListOfProducts = createListOfProducts;
